import { Button, Modal } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { PublicTransportDownloadSource } from "../../../types/LayerAdmin/PublicTransportDownloadSource";
import { usePublicTransportService } from "../../../hooks";
import { useState } from "react";

export interface DeleteSourceModalProps {
    source: PublicTransportDownloadSource;
    onClose: () => void;
    onDelete: () => void;
    show: boolean;
}

export const DeleteSourceModal = ({ source, show, onClose, onDelete }: DeleteSourceModalProps) => {
    const publicTransportService = usePublicTransportService();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteSource = () => {
        setIsDeleting(true);
        publicTransportService.IgnoreDownloadSource(source.id).then(() => {
            onDelete();
            onClose();
        }).catch((error: any) => {
            console.error(error);
        }).finally(() => {
            setIsDeleting(false);
        });
    }

    return <>
        <ThemedModal centered show={show} onHide={onClose}>
            <Modal.Header>
                <Modal.Title>Delete Source</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to delete the source <strong>{source.name}</strong>?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Cancel</Button>
                <Button variant="danger" onClick={handleDeleteSource} disabled={isDeleting}>Delete</Button>
            </Modal.Footer>
        </ThemedModal>
    </>
}